import { DataSourceList } from '@/components/DataSources/DataSourceList'
import { Route, Routes } from 'react-router-dom'

import type { FC } from 'react'

export const DataSourcesRoutes: FC = () => {
	return (
		<Routes>
			<Route index element={<DataSourceList />} />
			<Route path="csv" element={<DataSourceList />} />
		</Routes>
	)
}
